<template>
    <form-wrapper class="intake-work" @submit="handleFormSubmission(data)">
        <intake-form-section :title="$t('forms.intake.work_information.sections.employment')">
            <form-row>
                <form-cell>
                    <select-field
                        :label="$t('forms.intake.work_information.fields.employment_status.label')"
                        :placeholder="$t('forms.intake.work_information.fields.employment_status.placeholder')"
                        :options="employmentStatusOptions"
                        :formData="data"
                        valuePath="employmentStatus"
                        @change="change($event)"
                    ></select-field>
                </form-cell>
            </form-row>
        </intake-form-section>

        <template #footer>
            <common-buttons>
                <common-button
                    :label="$t('common.microcopy.back')"
                    type="secondary"
                    size="large"
                    :isSubmittable="false"
                    @click="goBack"
                ></common-button>
                <common-button
                    :label="$t('common.microcopy.next')"
                    type="primary"
                    size="large"
                    :isProcessing="isSending"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import IntakeFormSection from 'components/forms/intake/IntakeFormSection'

    const EMPLOYMENT_STATUSES = ['yes_employed', 'self_employed', 'student', 'retired', 'not_employed', 'other']

    export default {
        mixins: [FormMixin],

        components: {
            IntakeFormSection,
        },

        props: {
            initialData: { type: Object, default: undefined },
        },

        data() {
            return {
                data: {
                    employmentStatus: undefined,
                    ...(this.initialData || {}),
                },
            }
        },

        computed: {
            employmentStatusOptions() {
                return EMPLOYMENT_STATUSES.map((value) => ({
                    label: this.$t(`forms.intake.work_information.fields.employment_status.options.${value}`),
                    value,
                }))
            },
        },

        methods: {
            goBack() {
                this.emitEvent({ name: 'back', payload: this.data })
            },

            handleFormSubmission(data) {
                this.isSending = true
                this.emitSent(data)
                this.isSending = false
            },
        },
    }
</script>
